/**
 * Redirect whitelist editing helpers. No imports on purpose: the platform
 * websites form and its unit test use them without loading the Apollo client.
 */

/** Trim, drop trailing slashes and lowercase one redirect whitelist marker. */
export function normalizeRedirectWhitelistMarker(value: string): string {
  return value.trim().replace(/\/+$/, '').toLowerCase();
}

/** Add a marker to the whitelist; returns the new list and whether it was added (duplicates are skipped). */
export function addRedirectWhitelistUrl(
  list: string[],
  value: string,
): { list: string[]; added: boolean } {
  const marker = normalizeRedirectWhitelistMarker(value);
  if (!marker) {
    return { list, added: false };
  }
  if (list.some(item => normalizeRedirectWhitelistMarker(item) === marker)) {
    return { list, added: false };
  }
  return { list: [...list, marker], added: true };
}

/** Remove a marker from the whitelist by equality (after normalization). */
export function removeRedirectWhitelistUrl(list: string[], value: string): string[] {
  const marker = normalizeRedirectWhitelistMarker(value);
  return list.filter(item => normalizeRedirectWhitelistMarker(item) !== marker);
}
